/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsMagnifyingGlassXmark: {
  name: 'magnifying-glass-xmark';
  data: string;
} = {
  name: 'magnifying-glass-xmark',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 1.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM.5 7a6.5 6.5 0 1 1 11.436 4.23l3.418 3.416a.5.5 0 0 1-.708.708l-3.417-3.418A6.5 6.5 0 0 1 .5 7Zm8.854-1.646a.5.5 0 1 0-.708-.708L7 6.293 5.354 4.646a.5.5 0 1 0-.708.708L6.293 7 4.646 8.646a.5.5 0 1 0 .708.708L7 7.707l1.646 1.647a.5.5 0 1 0 .708-.708L7.707 7l1.647-1.646Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
